import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid g-0 accordion" }
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = { class: "col col-12" }
const _hoisted_4 = { class: "container-fluid g-0" }
const _hoisted_5 = { class: "row g-0" }

import { getCurrentInstance, inject, onMounted, onUnmounted, ref } from "vue";
import { Emitter } from "mitt";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressAccordionNoIcon',
  props: {
  accordionClass: {
    type: String,
    required: false,
  },
  groupId: {
    type: String,
    required: false,
  },
  isOpen: {
    type: Boolean,
    required: false,
    default: false,
  },
  preHeaderClickOnOpenFunction: {
    type: Function,
    required: false,
  },
},
  emits: {
  open: () => true,
  close: () => true,
},
  setup(__props, { emit: emits }) {

const props = __props;

const emitter = inject<Emitter<any>>("eventbus")!;


const currentInstance = getCurrentInstance()!;
const isOpenInternal = ref<boolean>(props.isOpen);
const maxHeight = ref<number>(0);
const contentEl = ref<HTMLElement>();

const onHeaderClick = async (ev) => {
  if (ev.target.tagName == "A") {
    return;
  }

  if (!isOpenInternal.value && props.preHeaderClickOnOpenFunction) {
    await props.preHeaderClickOnOpenFunction();
  }

  isOpenInternal.value = !isOpenInternal.value;
  if (isOpenInternal.value) {
    if (props.groupId) {
      emitter.emit(`accordions:${props.groupId}:close`, currentInstance.uid);
    }
    maxHeight.value = contentEl.value!.scrollHeight;
    setTimeout(() => {
      maxHeight.value = contentEl.value!.scrollHeight;
    }, 200);
    emits("open");
  } else {
    maxHeight.value = 0;
    emits("close");
  }
};
const onOpenHeaderClick = () => {
  isOpenInternal.value = true;
  if (isOpenInternal.value) {
    if (props.groupId) {
      emitter.emit(`accordions:${props.groupId}:close`, currentInstance.uid);
    }
    maxHeight.value = contentEl.value!.scrollHeight;
    setTimeout(() => {
      maxHeight.value = contentEl.value!.scrollHeight;
    }, 200);
    emits("open");
  } else {
    maxHeight.value = 0;
    emits("close");
  }
};

if (props.groupId) {
  const close = (id) => {
    if (currentInstance.uid != id) {
      isOpenInternal.value = false;
      maxHeight.value = 0;
    }
  };
  emitter.on(`accordions:${props.groupId}:close`, close);
  onUnmounted(() => {
    emitter.off(`accordions:${props.groupId}:close`, close);
  });
}
onMounted(() => {
  if (isOpenInternal.value) {
    onOpenHeaderClick();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "row g-0 align-items-center accordion__header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onHeaderClick($event)))
          }, [
            _renderSlot(_ctx.$slots, "header", {
              accordionClass: __props.accordionClass,
              isOpenInternal: isOpenInternal.value
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        ref_key: "contentEl",
        ref: contentEl,
        style: _normalizeStyle({ height: maxHeight.value + 'px' }),
        class: "col col-12 accordion__content"
      }, [
        _renderSlot(_ctx.$slots, "content")
      ], 4)
    ])
  ]))
}
}

})